
// const BlockDealers = ['19999']
// const BlockDealersSQL = 'AND cmp_code NOT IN (' + BlockDealers.map((d) => `'${d}'`).join(',') + ')'
/**The following querys should be used for testing */
//SQL query to get dealers outside the continental US
// SELECT LTRIM(RTRIM(cmp_code)) as id, cmp_name as name, cmp_fcity AS city, cmp_fpc AS zipcode
//             FROM dbo.cicmpy
// WHERE 
// 	LEN(cmp_fpc) >= 5 AND ISNUMERIC(LEFT(cmp_fpc, 5)) = 1 AND
//     ((CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 99501 AND 99950) OR -- Alaska
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96701 AND 96898) OR -- Hawaii
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 601 AND 999) OR     -- Puerto Rico and other territories
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96910 AND 96932) OR -- Guam
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) = 96799) OR                 -- American Samoa
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 801 AND 851) OR     -- U.S. Virgin Islands
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96950 AND 96952) OR -- Northern Mariana Islands
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96941 AND 96944) OR -- Federated States of Micronesia
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96960 AND 96970) OR -- Marshall Islands
//     (CAST(LEFT(cmp_fpc, 5) AS INTEGER) BETWEEN 96939 AND 96940) )   -- Palau
// 	 AND sct_code = 'DEALER'   AND cmp_status <> 'E'
// 	 ORDER BY zipcode
// SELECT LTRIM(RTRIM(cmp_code)) as id, cmp_name as name, cmp_fcity AS city, cmp_fpc AS zipcode, cmp_fadd1
// FROM dbo.cicmpy
// WHERE 
// (cmp_fadd1 LIKE '%PO BOX%') 
// AND sct_code = 'DEALER'   AND cmp_status <> 'E'
//SUNDANCE and JACUZZI Dealers:
// SELECT LTRIM(RTRIM(cmp_code)) as id, cmp_name as name, cmp_fcity AS city, cmp_fpc AS zipcode
// FROM [KING-SQL2014].[100_S].dbo.ItemAccounts
// INNER JOIN [KING-SQL2014].[100_S].dbo.cicmpy ON cmp_wwn = AccountCode
// WHERE  sct_code = 'DEALER' AND cmp_fctry = 'US' 
// AND cmp_status <> 'E' AND (textfield21 <> 'Red' OR textfield21 IS NULL)
// AND cmp_fadd1 is not null
// AND (ItemAccounts.ItemCode = 'SPAOEM0210' OR ItemAccounts.ItemCode = 'SPAOEM0163') 
// AND cmp_fadd1 NOT LIKE '%PO BOX%'
// AND cmp_code NOT IN ('19999')
// ORDER BY cmp_name ASC
// Function to check if a ZIP code is in the continental U.S.
export function isZipInContinentalUS(zipCode: string | number): boolean {
    // Convert the ZIP code to a number if it's a string
    const zip = typeof zipCode === 'string' ? parseInt(zipCode, 10) : zipCode;

    // Define ZIP code ranges that are outside the continental U.S.
    const nonContinentalRanges = [
        { lower: 601, upper: 999 }, // Puerto Rico and other territories
        { lower: 801, upper: 851 }, // U.S. Virgin Islands
        { lower: 9001, upper: 9899 }, //APO
        { lower: 9801, upper: 9899 }, //DPO
        { lower: 34001, upper: 34099 }, // FPO 1
        { lower: 99501, upper: 99950 }, // Alaska
        { lower: 96301, upper: 96699 }, // FPO 2
        { lower: 96701, upper: 96898 }, // Hawaii
        { lower: 96910, upper: 96932 }, // Guam
        { lower: 96799, upper: 96799 }, // American Samoa
        { lower: 96950, upper: 96952 }, // Northern Mariana Islands
        { lower: 96941, upper: 96944 }, // Federated States of Micronesia
        { lower: 96960, upper: 96970 }, // Marshall Islands
        { lower: 96939, upper: 96940 } // Palau
    ];


    // Check if the ZIP code falls within any of the non-continental U.S. ranges
    for (const range of nonContinentalRanges) {
        if (zip >= range.lower && zip <= range.upper) {
            return false;
        }
    }

    // If we've reached this point, the ZIP code is in the continental U.S.
    return true;
}
export function isAKorHI(zipCode: string | number): boolean {
    // Convert the ZIP code to a number if it's a string
    const zip = typeof zipCode === 'string' ? parseInt(zipCode, 10) : zipCode;

    // Define ZIP code ranges that are outside the continental U.S.
    const nonContinentalRanges = [
        { lower: 99501, upper: 99950 }, // Alaska
        { lower: 96701, upper: 96898 }, // Hawaii
    ];

    // Check if the ZIP code falls within any of the non-continental U.S. ranges
    for (const range of nonContinentalRanges) {
        if (zip >= range.lower && zip <= range.upper) {
            return true;
        }
    }

    // If we've reached this point, the ZIP code is in the continental U.S.
    return false;
}

export function isUSAStateZip(zipCode: string | number): boolean {
    // Convert the ZIP code to a number if it's a string
    const zip = typeof zipCode === 'string' ? parseInt(zipCode, 10) : zipCode;

    // Define ZIP code ranges that are outside the continental U.S.
    const nonUSAState = [
        { lower: 600, upper: 999 }, // Puerto Rico and other territories
        { lower: 801, upper: 851 }, // U.S. Virgin Islands
        { lower: 9001, upper: 9899 }, //APO
        { lower: 9801, upper: 9899 }, //DPO
        { lower: 34001, upper: 34099 }, // FPO 1

        //{ lower: 99501, upper: 99950 }, // Alaska
        { lower: 96301, upper: 96699 }, // FPO 2

        //{ lower: 96701, upper: 96898 }, // Hawaii
        { lower: 96910, upper: 96932 }, // Guam
        { lower: 96799, upper: 96799 }, // American Samoa
        { lower: 96950, upper: 96952 }, // Northern Mariana Islands
        { lower: 96941, upper: 96944 }, // Federated States of Micronesia
        { lower: 96960, upper: 96970 }, // Marshall Islands
        { lower: 96939, upper: 96940 } // Palau
    ];

    // Check if the ZIP code falls within any of the non-continental U.S. ranges
    for (const range of nonUSAState) {
        if (zip >= range.lower && zip <= range.upper) {
            return false;
        }
    }

    // If we've reached this point, the ZIP code is in the continental U.S.
    return true;
}
